import { render, staticRenderFns } from "./ShaftList.vue?vue&type=template&id=7604d70c&"
import script from "./ShaftList.vue?vue&type=script&lang=js&"
export * from "./ShaftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports